export const tags = [
    'StudyInstanceUID',
    'StudyDescription',
    'StudyDate',
    'StudyTime',
    'AccessionNumber',
];
